import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {SectionBlend} from './SectionBlend'

export type SectionBlendProps = SliceComponentProps<Content.SectionBlendSlice>

const SectionBlendSlice = ({slice}: SectionBlendProps): JSX.Element | null => {
  switch (slice.variation) {
    case 'default':
      return <SectionBlend blendDirection={slice.primary.blend_direction === 'Below' ? 'below' : 'above'} />

    default:
      return null
  }
}

export default SectionBlendSlice
